module.exports = {
  nav: {
    partners: "合作伙伴",
    recruitment: "人才招聘",
    bigEvent: "大事件",
    home: "首页",
    abount: "关于我们",
    ability: "核心能力",
    businessCase: "行业案例",
    countUs: "联系我们",
    lang:'中文',
    searchText:'请输入关键字',
  },
  home: {
    more: "查看更多",
    personnel: "技术人才库",
    serviceFirm: "服务企业人数",
    project: "累计项目",
    client: "累计客户",
    certification: "权威认证",
    program: "行业解决方案",
    advantage: "我们的优势",
    address: "地址",
    url: "网址",
    email: "邮箱",
    phone: "联系电话",
    yourMessage:'*您的留言',
    yourName:'*您的名字',
    yourPhone:'*您的手机号',
    yourEmail:'*您的邮箱',
    cooperation:'咨询合作',
    onTop:'返回顶部',
    countUsTitle:'用独具特色的全链路人才和技术服务为客户创造价值！',
  },
  abount:{
    profile:'公司简介',
    culture:'企业文化',
    advantage:'公司优势',
    team:'核心业务',
    qualification:'资质荣誉',
  },
  recruitment:{
    position:'职位名称',
    number:'招聘人数',
    details:'详情',
    ViewDetails:'查看详情',
    Apply:'应聘',
    submit:'提交'
  }
  
};



// WEBPACK FOOTER //
// ./src/lang/zh.js